import { useState, useEffect, useRef } from "react";
import DashboardLayout from "./common/DashboardApp";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ProgressBar from "../employer/dashboard/ProgressBar";
import Loader from "./common/Loader";
import {
  getProgressData,
  getDashboardData,
  getProfileData,
  candidatePayments,
  getTaskData,
} from "../../service/employerapi";
import TermsModal from "./dashboard/TermsModal";

const EmployerDashboard = () => {
  const [pendingPayments, setPendingPayments] = useState([]);
  const [progressData, setProgressData] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dashboardTasks, setDashboardTasks] = useState([]);
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1️⃣ Fetch progress
        const progress = await getProgressData();
        console.log("Progress API:", progress);
        if (progress?.data) setProgressData(progress);

        // 2️⃣ Fetch dashboard
        const dashboard = await getDashboardData();
        console.log("Dashboard API:", dashboard);
        if (dashboard?.data) setDashboardData(dashboard);

        // 3️⃣ Fetch profile
        const profile = await getProfileData();
        console.log("Profile API:", profile);
        if (profile?.data) setProfileData(profile);

        // 4️⃣ Fetch pending payments
        const payments = await candidatePayments();
        console.log("Payments API:", payments);
        setPendingPayments(payments?.data?.approvedPaymentList || []);

        // 5️⃣ Fetch dashboard tasks (depends on dashboardData)
        if (dashboard?.data?.applicationId) {
          const tasks = await getTaskData(dashboard.data.applicationId);
          console.log("Dashboard Tasks API:", tasks);
          setDashboardTasks(tasks?.data || []);
        }
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchDashboardTasks = async () => {
      try {
        if (!dashboardData?.data?.applicationId) return;

        const res = await getTaskData(dashboardData.data.applicationId);
        setDashboardTasks(res?.data || []);
      } catch (err) {
        console.error("Dashboard task fetch error", err);
      }
    };

    fetchDashboardTasks();
  }, [dashboardData]);

  useEffect(() => {
    if (dashboardData?.data?.termCondition === false) {
      setShowTerms(true);
    }
  }, [dashboardData]);

  const handleAcceptTerms = () => {
    setShowTerms(false);
  };

  return (
    <DashboardLayout>
      {showTerms && <TermsModal onAccept={handleAcceptTerms} />}

      <div className="panelMainWrapper">
        <div className="panelCard">
          {/* Progress popup */}
          <ProgressBar progressData={progressData} />

          <div className="row align-item-center g-0">
            <div className="col-md-7 g-0">
              <div className="profileShortInfo">
                <h4>
                  Welcome Back,{" "}
                  <span>{profileData?.data?.companyName || "Employer"}</span>
                </h4>
                <p>
                  {profileData?.data?.aboutCompany
                    ? profileData.data.aboutCompany.length > 200
                      ? profileData.data.aboutCompany.substring(0, 200) + "..."
                      : profileData.data.aboutCompany
                    : ""}
                </p>
              </div>
            </div>
            <div className="col-md-5 g-0">
              <div className="profileDashCard">
                <div className="profiledashDP">
                  <div
                    className="avatar rounded-circle"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundImage: `url(${
                        profileData?.data?.image ||
                        "/assets/img/default-avatar.png"
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                </div>
                <div className="profileDashContent">
                  <h5>{profileData?.data?.companyName || "Employer"}</h5>
                  <p>{profileData?.data?.email || "info@example.com"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <a href="javascript:void(0)">
              <div
                className="categoryCard wow animate__zoomIn"
                style={{ visibility: "visible", animationName: "zoomIn" }}
              >
                <div className="categoryHeader">
                  <div className="categoryImg">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/icons/compnay-profile-color.svg`}
                      alt="img"
                    />
                  </div>
                  <div className="categoryContent">
                    <h4>
                      <span
                        className="counter"
                        data-final-value={
                          dashboardData?.data?.candidatesApplied
                        }
                      >
                        {dashboardData?.data?.candidatesApplied ?? 0}
                      </span>
                    </h4>
                    <p>Candidates Applied</p>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="javascript:void(0)">
              <div
                className="categoryCard wow animate__zoomIn"
                style={{ visibility: "visible", animationName: "zoomIn" }}
              >
                <div className="categoryHeader">
                  <div className="categoryImg">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/icons/connected-candidates-color.svg`}
                      alt="img"
                    />
                  </div>
                  <div className="categoryContent">
                    <h4>
                      <span
                        className="counter"
                        data-final-value={dashboardData?.data?.postedJobs}
                      >
                        {dashboardData?.data?.postedJobs ?? 0}
                      </span>
                    </h4>
                    <p>Posted Jobs</p>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="javascript:void(0)">
              <div
                className="categoryCard wow animate__zoomIn"
                style={{ visibility: "visible", animationName: "zoomIn" }}
              >
                <div className="categoryHeader">
                  <div className="categoryImg">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/icons/Subscriptions-color.svg`}
                      alt="img"
                    />
                  </div>
                  <div className="categoryContent">
                    <h4>
                      <span
                        className="counter"
                        data-final-value={dashboardData?.data?.profileViews}
                      >
                        {dashboardData?.data?.profileViews ?? 0}
                      </span>
                    </h4>
                    <p>Profile Views</p>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        {/* Pending Payments & New Tasks */}
        <div className="row mt-4">
          <div className="col-md-6 mb-3">
            <div className="hj-dashboard-box">
              <div className="hj-dashboard-header">
                <h5>Pending Payments</h5>
                <i className="fa-solid fa-wallet"></i>
              </div>

              {pendingPayments.length === 0 ? (
                <p className="hj-empty-text">No pending payments 🎉</p>
              ) : (
                <ul className="hj-dashboard-list">
                  {pendingPayments.slice(0, 3).map((payment, index) => (
                    <li key={index}>
                      <span>
                        {payment.jobTitle}
                        <div className="hj-subtext">
                          {payment.jobSeekerName}
                        </div>
                      </span>
                      <strong>₹{payment.totalAmount}</strong>
                    </li>
                  ))}
                </ul>
              )}

              <a href="employer/make-payment" className="hj-dashboard-link">
                View All Payments
              </a>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="hj-dashboard-box">
              <div className="hj-dashboard-header">
                <h5>New Tasks</h5>
                <i className="fa-solid fa-list-check"></i>
              </div>

              {dashboardTasks.length === 0 ? (
                <p className="hj-empty-text">No tasks available</p>
              ) : (
                <ul className="hj-dashboard-list hj-task-list">
                  {dashboardTasks.slice(0, 3).map((task, index) => (
                    <li key={index}>
                      <span>
                        {task.title}
                        <div className="hj-subtext">
                          {task.hoursWorked} hrs · {task.progressPercent}%
                        </div>
                      </span>

                      <span
                        className={`hj-task-badge ${
                          task.employerApprovedTask === "Approved"
                            ? "approved"
                            : task.employerApprovedTask === "Rejected"
                              ? "rejected"
                              : task.employerApprovedTask === "Modified"
                                ? "modified"
                                : "pending"
                        }`}
                      >
                        {task.employerApprovedTask || "Pending"}
                      </span>
                    </li>
                  ))}
                </ul>
              )}

              <a
                href={`/employer/connected-candidates}`}
                className="hj-dashboard-link"
              >
                View All Tasks
              </a>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EmployerDashboard;
